import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { Link, Render } from '@components/Shared';

import { PlatformAppLogo } from './PlatformAppLogo';

type Props = {
  title?: string;
  description?: string;
  icon?: IconProp;
  image?: string;
  link?: string;
};

export const PlatformAppItem: React.FC<Props> = ({
  title,
  description,
  image,
  link,
}) => {
  const content = (
    <>
      <PlatformAppLogo src={image} />

      <div>
        <Render if={title}>
          <p className="text-headline transition-colors group-hover:text-primary">
            {title}
          </p>
        </Render>

        <Render if={description}>
          <p className="mt-1 line-clamp-3 text-neural-04">{description}</p>
        </Render>
      </div>
    </>
  );

  if (link) {
    return (
      <Link to={link} theme external blank className="group flex gap-4">
        {content}
      </Link>
    );
  }

  return <div className="flex gap-4">{content}</div>;
};
